import { RequestUrl } from '../types';
import { convertToCamelCase, getHttpRequestSettings } from '../utils';
export async function clearBasketHandler() {
  const response = await fetch(RequestUrl.ClearBasket, getHttpRequestSettings());
  return convertToCamelCase(await response.json());
}
//# sourceMappingURL=clearBasketHandler.js.map